import styled from 'styled-components';

interface Props {
	showTimer?: boolean;
}

export const Container = styled.div``;

export const Padding20 = styled.div<Props>`
	padding: ${({ showTimer }) => (showTimer ? '82px 20px 30px 20px' : '20px 20px 30px 20px')};
`;

export const MarginTop32 = styled.div`
	margin-top: 32px;
`;
